






import Vue from 'vue';

import OrganizationPeerGroup from '@/views/authenticated/OrganizationPeerGroup.vue';
import OrganizationLoadGuard from '@/components/OrganizationLoadGuard.vue';

export default Vue.extend({
  components: {
    OrganizationPeerGroup,
    OrganizationLoadGuard
  },

  props: {
    organizationId: Number,
    peerGroupId: Number
  }
});
